import { useMemo } from 'react';

import { useGetSurveysQuery } from 'services/surveys/surveys';

import { Survey } from 'models/survey.types';

/**
 * The surveys the patient should be prompted with: `GET /surveys` minus the ones snoozed with "remind me later".
 * Readers that act on a survey the patient named or already opened read the full `useGetSurveysQuery` list instead, so they still find a snoozed one.
 */
export const getActiveSurveys = (surveys: Survey[]): Survey[] =>
  surveys.filter((survey) => !survey.snoozedUntil);

export const useActiveSurveys = (): { surveys: Survey[] } => {
  const { data } = useGetSurveysQuery();

  const surveys: Survey[] = useMemo(() => getActiveSurveys(data ?? []), [data]);

  return { surveys };
};
